export const perPage = function (state, getters) {
  return state.perPage
}

export const currentUser = function (state, getters) {
  return state.currentUser
}

export const currentCompany = function (state, getters) {
  return state.currentCompany
}

export const qualityUpperLimit = function (state, getters) {
  return state.qualityUpperLimit
}

export const qualityLowerLimit = function (state, getters) {
  return state.qualityLowerLimit
}

export const statuses = function (state, getters) {
  return state.statuses
}

export const workOrderStatus = function (state, getters) {
  return state.workOrderStatus
}

export const picklistStatus = function (state, getters) {
  return state.picklistStatus
}

export const picklistUnits = function (state, getters) {
  return state.picklistUnits
}

export const selectedFlataRows = function (state, getters) {
  return state.selectedFlataRows
}

export const selectedFlata = function (state, getters) {
  return state.selectedFlata
}

export const workOrderUnit = function (state, getters) {
  return state.workOrderUnit
}

export const workOrderResponsible = function (state, getters) {
  return state.workOrderResponsible
}

export const responsibleSeller = function (state, getters) {
  return state.responsibleSeller
}

export const currentCompanyName = function (state, getters) {
  var cc = state.currentUser.companies.filter(function (x) {
    if (x.id === state.currentCompany) {
      return x
    }
  })
  return cc[0].name
}

export const apiUrl = function (state, getters) {
  return state.apiUrl
}

export const uploadUrl = function (state, getters) {
  return state.apiUrl.replace('/api', '')
}

export const currentReport = function (state, getters) {
  return state.currentReports
}

export const currentReportName = function (state, getters) {
  return state.currentReportName
}

export const selectedReportRows = function (state, getters) {
  return state.selectedReportRows
}

export const currentCompanySelectedReportRows = function (state, getters) {
  return state.selectedReportRows[state.currentCompany]
}

export const currentCompanyReport = function (state, getters) {
  return state.currentReports[state.currentCompany]
}

export const routeData = function (state, getters) {
  return state.routeData
}

export const nodeEnv = function (state, getters) {
  return state.nodeEnv
}

export const newReport = function (state) {
  return state.newReport
}

export const newReportSelectedJoints = function (state) {
  return state.newReport.selectedJoints
}

export const newReportSelectedJointIds = function (state) {
  return state.newReport.selectedJointIds
}

export const isJointInNewReport = function (state) {
  return function (jointId) {
    return state.newReport.selectedJointIds.indexOf(jointId) !== -1
  }
}

export const reportFieldConfig = function (state) {
  if (state.newReport.customerConfig && state.newReport.customerConfig.report_field_config) {
    var config = state.newReport.customerConfig.report_field_config
    if (typeof config === 'string') {
      try {
        config = JSON.parse(config)
      } catch (e) {
        return null
      }
    }
    return config
  }
  return null
}

export const fieldWork = function (state) {
  return state.fieldWork
}

export const fieldWorkActiveReport = function (state) {
  if (!state.fieldWork.activeReportId) {
    return null
  }
  return state.fieldWork.reports.find(function (r) {
    return r.id === state.fieldWork.activeReportId
  }) || null
}



// WEBPACK FOOTER //
// ./src/store/getters.js